import * as React from 'react';

const Camera16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.5 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.5 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.728 1c-1.107 0-1.813.774-2.539 1.5H2.75A2.75 2.75 0 0 0 0 5.25v7A2.75 2.75 0 0 0 2.75 15h10.5A2.75 2.75 0 0 0 16 12.25v-7a2.75 2.75 0 0 0-2.75-2.75h-1.44C11.086 1.774 10.38 1 9.273 1zm0 1.5h2.544c1.068 0 1.373 1.5 2.435 1.5h1.543c.69 0 1.25.56 1.25 1.25v7c0 .69-.56 1.25-1.25 1.25H2.75c-.69 0-1.25-.56-1.25-1.25v-7C1.5 4.56 2.06 4 2.75 4h1.543c.331 0 .65-.132.884-.366.44-.44.868-1.134 1.551-1.134"
  }
));
Camera16.Size = 16;
Camera16.Title = "Camera";

export { Camera16 as default };
